<template>
  <div>
    <div class="info-title">{{ title }}</div>

    <div class="form-info-panel" style="padding: 0.4rem; text-align: left">
      <div
        v-for="(item, index) in course_data"
        style="padding-bottom: 24px"
        @click="editPerson(item, index)"
      >
        <div style="position: relative">
          <div style="font-size: 14px; font-weight: bold">
            <!-- {{ item.name ? item.name : "??" }} -->

            <!-- {{ item.val1 }},{{ item.val2 }},{{ item.val3 }},{{ item.val4 }} -->
            <div v-if="type == 1">{{ item.val2 }}-{{ item.val3 }}</div>
            <div v-if="type == 2">{{ item.val0 }}</div>
            <div v-if="type == 3">{{ item.val1 }}</div>
            <div v-if="type == 4">{{ item.val1 }}</div>
            <div v-if="type == 5">{{ item.val1 }}</div>
            <div v-if="type == 7">{{ item.val0 }}</div>
          </div>
          <div style="font-size: 12px; margin-top: 6px">
            <!-- 1223 -->
            <!-- {{ item.val5 }},{{ item.val6 }},{{ item.val7 }} -->

            <div v-if="type == 1">出发日期：{{ item.val0 }}</div>
            <div v-if="type == 2">
              入住时间：{{ item.val2 }}，离开时间：{{ item.val3 }}
            </div>
            <div v-if="type == 3">服务日期：{{ item.val0 }}</div>
            <div v-if="type == 4">服务日期：{{ item.val0 }}</div>
            <div v-if="type == 5">签注日期：{{ item.val3 }}</div>
            <div v-if="type == 7">条款细则：略</div>
          </div>

          <div
            style="
              position: absolute;
              right: 0;
              font-size: 22px !important;
              top: 50%;
              transform: translateY(-50%);
              color: #1889f9 !important;
            "
          >
            <van-icon
              name="edit"
              style="
                display: inline-block;
                vertical-align: middle;
                font-size: 22px !important;
                color: #1889f9 !important;
              "
            />
          </div>
        </div>
      </div>

      <a
        style="
          display: inline-block;
          width: 100%;
          border-radius: 0.125rem;
          line-height: 0.7rem;
          font-family: PingFangSC-Regular;
          font-size: 0.3rem;
          color: #1889f9;
          border: 1px solid #9f9f9f;
          text-align: center;
        "
        href="javascript:void(0);"
        v-on:click="addCourse"
        v-if="type != 6"
      >
        <van-icon
          name="add-o"
          style="
            display: inline-block;
            margin-right: 6px;
            vertical-align: middle;
          "
        />
        <span style="display: inline-block; vertical-align: middle">添加</span>
      </a>

      <!-- start of 附加信息 -->
      <div
        style="margin-top: 16px"
        v-if="(course_data.length || type == 6) && type != 7"
      >
        <div v-if="type == 1">
          <div class="cus-row cus-row-v-m">
            <div class="cus-row-col-4">
              <span class="input-tag">税费</span>
            </div>
            <div class="cus-row-col-8 select-line">
              <input
                class="line-input"
                style=""
                placeholder="必填"
                type="number"
                v-model="tax"
              />
            </div>
          </div>

          <div class="barrie-line"></div>
        </div>

        <div v-if="type != 2">
          <div class="cus-row cus-row-v-m">
            <div class="cus-row-col-4">
              <span class="input-tag">数量</span>
            </div>
            <div class="cus-row-col-8 select-line">
              <input
                class="line-input"
                type="number"
                style=""
                placeholder="必填"
                v-model="num"
              />
            </div>
          </div>

          <div class="barrie-line"></div>
        </div>

        <div>
          <div class="cus-row cus-row-v-m">
            <div class="cus-row-col-4">
              <span class="input-tag">费用合计</span>
            </div>
            <div class="cus-row-col-8 select-line">
              <input
                class="line-input"
                type="number"
                style=""
                placeholder="必填"
                v-model="price"
              />
            </div>
          </div>

          <div class="barrie-line"></div>
        </div>

        <div v-if="type == 5">
          <div class="cus-row cus-row-v-m">
            <div class="cus-row-col-4">
              <span class="input-tag">截至日期</span>
            </div>
            <div class="cus-row-col-8 select-line">
              <!-- <input
                class="line-input"
                style=""
                placeholder="必填"
                v-model="deadline"
              /> -->
              <input
                class="line-input"
                type="text"
                style=""
                placeholder="必填"
                readonly
                onfocus="this.blur()"
                :value="$refs.deadline ? $refs.deadline.dateStr : ''"
                @click="$refs.deadline.doSelect()"
              />
            </div>
          </div>

          <div class="barrie-line"></div>
        </div>

        <div>
          <div class="cus-row cus-row-v-m">
            <div class="cus-row-col-4">
              <span class="input-tag">其他费用及说明</span>
            </div>
            <div class="cus-row-col-8 select-line">
              <input
                class="line-input"
                type="text"
                style=""
                v-model="remark"
                placeholder="非必填"
              />
            </div>
          </div>

          <div class="barrie-line"></div>
        </div>
      </div>
      <!-- end of 附加信息 -->
    </div>

    <!-- start of 游客编辑 -->
    <van-popup
      v-model="person_show"
      position="right"
      style="width: 82%; height: 100%; background: #f5f5f5"
    >
      <!--字符、注册年限、组合类型、注册类型、年限进行筛选-->

      <div
        style="
          box-shadow: 0px 2px 5px #eeeeee;
          background: #ffffff;
          margin-top: 2px;
        "
      >
        <van-cell title="" is-link value="关闭" @click="person_show = false" />
      </div>

      <!--用tab操作-->
      <div style="overflow-y: scroll; height: calc(100% - 90px)">
        <div style="padding: 12px">
          <van-form>
            <div v-for="(item, index) in book_columns">
              <!-- 通用：数字输入 -->
              <van-field
                v-if="item.show_type == 'number'"
                :label="item.name"
                type="number"
                v-model="current_person['val' + index]"
              >
              </van-field>
              <!-- start of  0 -->
              <van-field
                :label="item.name"
                v-model="current_person.val0"
                v-if="index == 0 && !item.show_type"
              >
              </van-field>

              <!-- <van-field
                :label="item.name"
                readonly
                onfocus="this.blur()"
                v-model="current_person.val0"
                v-if="(index == 0) && item.show_type=='date'"
                @click="showCommonDate('val0', current_person.val0)"
              >
              </van-field> -->

              <div
                class="van-cell van-field"
                v-if="index == 0 && item.show_type == 'date'"
              >
                <div class="van-cell__title van-field__label">
                  <span>{{ item.name }}</span>
                </div>
                <div class="van-cell__value van-field__value">
                  <div class="van-field__body">
                    <input
                      class="van-field__control"
                      type="text"
                      style=""
                      placeholder="必填"
                      readonly
                      onfocus="this.blur()"
                      :value="$refs.val0 ? $refs.val0.dateStr : ''"
                      @click="$refs.val0.doSelect()"
                    />

                    <!-- <input type="text" name="radio" class="van-field__control" /> -->
                    <!-- <select
        
                      style="padding: 0"
                      class="line-select"
                      v-model="current_person.val0"
                    >
                      <option :value="option.value" v-for="(option, option_index) in item.options">{{ option.name }}</option>
                     
                    </select> -->
                  </div>
                </div>
              </div>

              <div
                class="van-cell van-field"
                v-if="index == 0 && item.show_type == 'select'"
              >
                <div class="van-cell__title van-field__label">
                  <span>{{ item.name }}</span>
                </div>
                <div class="van-cell__value van-field__value">
                  <div class="van-field__body">
                    <!-- <input type="text" name="radio" class="van-field__control" /> -->
                    <select
                      style="padding: 0"
                      class="line-select"
                      v-model="current_person.val0"
                    >
                      <option
                        :value="option.value"
                        v-for="(option, option_index) in item.options"
                      >
                        {{ option.name }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>

              <!-- start of  1 -->

              <van-field
                :label="item.name"
                v-model="current_person.val1"
                v-if="index == 1 && !item.show_type"
              >
              </van-field>

              <div
                class="van-cell van-field"
                v-if="index == 1 && item.show_type == 'date'"
              >
                <div class="van-cell__title van-field__label">
                  <span>{{ item.name }}</span>
                </div>
                <div class="van-cell__value van-field__value">
                  <div class="van-field__body">
                    <input
                      class="van-field__control"
                      type="text"
                      style=""
                      placeholder="必填"
                      readonly
                      onfocus="this.blur()"
                      :value="$refs.val1 ? $refs.val1.dateStr : ''"
                      @click="$refs.val1.doSelect()"
                    />
                  </div>
                </div>
              </div>
              <van-field
                :label="item.name"
                v-model="current_person.val1"
                v-if="index == 1 && item.show_type == 'textarea'"
                type="textarea"
                row="8"
              >
              </van-field>

              <!-- start of  2 -->

              <van-field
                :label="item.name"
                v-model="current_person.val2"
                v-if="index == 2 && !item.show_type"
              >
              </van-field>

              <div
                class="van-cell van-field"
                v-if="index == 2 && item.show_type == 'date'"
              >
                <div class="van-cell__title van-field__label">
                  <span>{{ item.name }}</span>
                </div>
                <div class="van-cell__value van-field__value">
                  <div class="van-field__body">
                    <input
                      class="van-field__control"
                      type="text"
                      style=""
                      placeholder="必填"
                      readonly
                      onfocus="this.blur()"
                      :value="$refs.val2 ? $refs.val0.dateStr : ''"
                      @click="$refs.val2.doSelect()"
                    />
                  </div>
                </div>
              </div>

              <div
                class="van-cell van-field"
                v-if="index == 2 && item.show_type == 'select'"
              >
                <div class="van-cell__title van-field__label">
                  <span>{{ item.name }}</span>
                </div>
                <div class="van-cell__value van-field__value">
                  <div class="van-field__body">
                    <!-- <input type="text" name="radio" class="van-field__control" /> -->
                    <select
                      style="padding: 0"
                      class="line-select"
                      v-model="current_person.val2"
                    >
                      <option
                        :value="option.value"
                        v-for="(option, option_index) in item.options"
                      >
                        {{ option.name }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>

              <!-- start of  3 -->

              <van-field
                :label="item.name"
                v-model="current_person.val3"
                v-if="index == 3 && !item.show_type"
              >
              </van-field>

              <div
                class="van-cell van-field"
                v-if="index == 3 && item.show_type == 'date'"
              >
                <div class="van-cell__title van-field__label">
                  <span>{{ item.name }}</span>
                </div>
                <div class="van-cell__value van-field__value">
                  <div class="van-field__body">
                    <input
                      class="van-field__control"
                      type="text"
                      style=""
                      placeholder="必填"
                      readonly
                      onfocus="this.blur()"
                      :value="$refs.val3 ? $refs.val3.dateStr : ''"
                      @click="$refs.val3.doSelect()"
                    />
                  </div>
                </div>
              </div>

              <div
                class="van-cell van-field"
                v-if="index == 3 && item.show_type == 'select'"
              >
                <div class="van-cell__title van-field__label">
                  <span>{{ item.name }}</span>
                </div>
                <div class="van-cell__value van-field__value">
                  <div class="van-field__body">
                    <!-- <input type="text" name="radio" class="van-field__control" /> -->
                    <select
                      style="padding: 0"
                      class="line-select"
                      v-model="current_person.val3"
                    >
                      <option
                        :value="option.value"
                        v-for="(option, option_index) in item.options"
                      >
                        {{ option.name }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>

              <!-- start of  4 -->

              <van-field
                :label="item.name"
                v-model="current_person.val4"
                v-if="index == 4 && !item.show_type"
              >
              </van-field>

              <div
                class="van-cell van-field"
                v-if="index == 4 && item.show_type == 'date'"
              >
                <div class="van-cell__title van-field__label">
                  <span>{{ item.name }}</span>
                </div>
                <div class="van-cell__value van-field__value">
                  <div class="van-field__body">
                    <input
                      class="van-field__control"
                      type="text"
                      style=""
                      placeholder="必填"
                      readonly
                      onfocus="this.blur()"
                      :value="$refs.val4 ? $refs.val0.dateStr : ''"
                      @click="$refs.val4.doSelect()"
                    />
                  </div>
                </div>
              </div>

              <div
                class="van-cell van-field"
                v-if="index == 4 && item.show_type == 'select'"
              >
                <div class="van-cell__title van-field__label">
                  <span>{{ item.name }}</span>
                </div>
                <div class="van-cell__value van-field__value">
                  <div class="van-field__body">
                    <!-- <input type="text" name="radio" class="van-field__control" /> -->
                    <select
                      style="padding: 0"
                      class="line-select"
                      v-model="current_person.val4"
                    >
                      <option
                        :value="option.value"
                        v-for="(option, option_index) in item.options"
                      >
                        {{ option.name }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>

              <!-- start of  5 -->

              <van-field
                :label="item.name"
                v-model="current_person.val5"
                v-if="index == 5 && !item.show_type"
              >
              </van-field>

              <!-- start of 6 -->
              <van-field
                :label="item.name"
                v-model="current_person.val6"
                v-if="index == 6 && !item.show_type"
              >
              </van-field>

              <div
                class="van-cell van-field"
                v-if="index == 6 && item.show_type == 'date'"
              >
                <div class="van-cell__title van-field__label">
                  <span>{{ item.name }}</span>
                </div>
                <div class="van-cell__value van-field__value">
                  <div class="van-field__body">
                    <input
                      class="van-field__control"
                      type="text"
                      style=""
                      placeholder="必填"
                      readonly
                      onfocus="this.blur()"
                      :value="$refs.val6 ? $refs.val6.dateStr : ''"
                      @click="$refs.val6.doSelect()"
                    />
                  </div>
                </div>
              </div>

              <van-field
                :label="item.name"
                v-model="current_person.val7"
                v-if="index == 7 && !item.show_type"
              >
              </van-field>
            </div>

            <!-- <van-field
              name="checkboxGroup"
              label="姓名"
              v-model="current_person.name"
            >
            </van-field>
         

            <div class="van-cell van-field">
              <div class="van-cell__title van-field__label">
                <span>证件类型</span>
              </div>
              <div class="van-cell__value van-field__value">
                <div class="van-field__body">
                 
                  <select
                    v-model="current_person.cardtype"
                    style="padding: 0"
                    class="line-select"
                  >
                    <option value="1">身份证</option>
                    <option value="4">护照</option>
                    <option value="6">回乡证</option>
                    <option value="8">其他</option>
                  </select>
                </div>
              </div>
            </div> -->

            <!-- <van-field
              name="checkboxGroup"
              label="证件号"
              v-model="current_person.idcard"
            >
            </van-field>

            <van-field
              name="checkboxGroup"
              label="手机号码"
              v-model="current_person.phone"
            >
            </van-field>

          
            <div class="van-cell van-field">
              <div class="van-cell__title van-field__label">
                <span>是否儿童</span>
              </div>
              <div class="van-cell__value van-field__value">
                <div class="van-field__body">
                
                  <select
                    v-model="current_person.is_child"
                    style="padding: 0"
                    class="line-select"
                  >
                    <option value="1">是</option>
                    <option value="2">否</option>
                  </select>
                </div>
              </div>
            </div>

            <van-field
              name="checkboxGroup"
              label="地址"
              v-model="current_person.address"
              type="textarea"
              rows="2"
            >
            </van-field> -->
          </van-form>
        </div>
      </div>

      <div style="position: absolute; left: 0; right: 0; bottom: 0">
        <div class="cus-row">
          <div class="cus-row-col-6">
            <van-button
              type="danger"
              block
              style="background: #ffffff; color: #000000; border: none"
              @click="deletePerson"
              >删除</van-button
            >
          </div>
          <div class="cus-row-col-6">
            <van-button type="danger" block @click="choseTemplate"
              >继续
            </van-button>
          </div>
        </div>
      </div>
    </van-popup>
    <!-- end of 游客编辑 -->

    <CusDatePicker ref="deadline" v-model="deadline"></CusDatePicker>

    <CusDatePicker ref="val0" v-model="current_person.val0" :overlay="false"></CusDatePicker>

    <CusDatePicker ref="val1" v-model="current_person.val1"  :overlay="false"></CusDatePicker>

    <CusDatePicker ref="val2" v-model="current_person.val2"></CusDatePicker>

    <CusDatePicker ref="val3" v-model="current_person.val3"></CusDatePicker>

    <CusDatePicker ref="val4" v-model="current_person.val4"></CusDatePicker>

    <CusDatePicker ref="val6" v-model="current_person.val6"></CusDatePicker>

    <!-- <CusDatePicker
      ref="val"
      v-model="deadline"
    ></CusDatePicker> -->
  </div>
</template>

<script>
import { Dialog } from "vant";
import CusDatePicker from "../modules/cus_date_picker";

export default {
  name: "CheeseFooter",
  props: ["footerType", "addUrl", "title", "type"],
  components: {
    CusDatePicker,
  },
  watch: {
    // commondate: function (newval) {
    //   // console.log("检测到commondate变化", this.commondate)
    //   // if(this.current_person && this.date_key ){
    //   //   if(this.current_person[this.date_key] != this.commondate){
    //   //     console.log("改变值")
    //   //     this.current_person[this.date_key] = newval
    //   //   }
    //   // }
    // },
  },
  created: function () {
    console.log(this.footerType);

    console.log("新建机票预定");

    if (this.type == 1) {
      this.book_columns = [
        {
          name: "出发日期",
          show_type: "date",
        },
        {
          name: "返回日期",
          show_type: "date",
        },
        {
          name: "出发城市",
        },
        {
          name: "到达城市",
        },
        {
          name: "类型",
          show_type: "select",
          options: [
            { name: "单程", value: 1 },
            { name: "往返", value: 2 },
          ],
        },
        {
          name: "张数",
          show_type: "number"
        },
      ];

      console.log("输出show_type没关系吧");
    }

    if (this.type == 2) {
      this.book_columns = [
        {
          name: "国家/城市",
        },
        {
          name: "酒店名称",
        },
        {
          name: "入住时间",
          show_type: "date",
        },
        {
          name: "离开时间",
          show_type: "date",
        },
        {
          name: "房型",
          show_type: "select",
          options: [
            { name: "标准间", value: 4 },
            { name: "单人间", value: 5 },
            { name: "三人间", value: 6 },
            { name: "加床", value: 10 },
            { name: "其他", value: 99 },
          ],
        },
        {
          name: "数量",
          show_type: "number"
        },
        {
          name: "单价",
          show_type: "number"
        },
      ];
    }

    if (this.type == 3) {
      this.book_columns = [
        {
          name: "服务日期",
          show_type: "date",
        },
        {
          name: "车型",
        },
        {
          name: "乘车人数",
          show_type: "number"
        },
        {
          name: "服务类型",
          show_type: "select",
          options: [
            { name: "接送机单程", value: 1 },
            { name: "接送机往返", value: 2 },
            { name: "其他", value: 99 },
          ],
        },
        {
          name: "出发地",
        },
        {
          name: "目的地",
        },
        {
          name: "单价",
          show_type: "number"
        },
      ];
    }

    if (this.type == 4) {
      this.book_columns = [
        {
          name: "服务日期",
          show_type: "date",
        },
        {
          name: "语种",
        },
        {
          name: "性别",
          show_type: "select",
          options: [
            { name: "男", value: 0 },
            { name: "女", value: 1 },
          ],
        },
        {
          name: "数量",
          show_type: "number"
        },
      ];
    }

    if (this.type == 5) {
      this.book_columns = [
        {
          name: "类型",
          show_type: "select",
          options: [
            { name: "签证", value: 1 },
            { name: "签注", value: 2 },
            { name: "入台证", value: 3 },
          ],
        },
        {
          name: "国家/地区",
        },
        {
          name: "前往事由",
          show_type: "select",
          options: [
            { name: "旅游", value: 1 },
            { name: "商务", value: 2 },
          ],
        },
        {
          name: "签注日期",
          show_type: "number",
        },
        {
          name: "入境次数",
          show_type: "number",
        },
        {
          name: "签注工作日（约）",
          show_type: "number",
        },
        {
          name: "预计出行日期",
          show_type: "date",
        },
        {
          name: "费用",
          show_type: "number"
        },
      ];
    }

    if (this.type == 7) {
      this.book_columns = [
        {
          name: "标题",
        },
        {
          name: "内容",
          show_type: "textarea",
        },
      ];
    }
  },
  data: function () {
    return {
      person_show: false,
      current_person: {},
      course_data: [],
      book_type: 1,
      book_columns: [],
      tax: "",
      price: "",
      remark: "",
      deadline: "",
      num: "",
      commondate: "",
      date_key: false,
    };
  },
  methods: {
    showCommonDate(key, val) {
      console.log("展示中转的时间选择", key, val);
      this.commondate = val;

      this.date_key = key;

      this.$refs.commondate.doSelect();
    },
    getData() {
      return JSON.stringify({
        tax: this.tax,
        price: this.price,
        remark: this.remark,
        num: this.num,
        deadline: this.deadline,
        data: this.course_data,
      });
    },
    deletePerson() {
      Dialog.confirm({
        title: "操作提醒",
        message: "是否要删除当前信息？",
      }).then(() => {
        this.person_show = false;
        // _.remove(this.course_data,);
        this.course_data.splice(this.person_index, 1);
        this.person_index = -1;
      });
    },

    editPerson(item, index) {
      this.person_index = index;
      this.current_person = this.course_data[this.person_index];
      this.person_show = true;
    },
    add() {
      this.$router.push(this.addUrl);
    },

    choseTemplate() {
      this.person_show = false;
    },

    init(info) {
      if (!info) {
        return;
      }

      console.log("输出初始化的数据", info);

      info = JSON.parse(info);
      this.tax = info.tax;
      this.price = info.price;
      this.remark = info.remark;
      this.num = info.num;
      this.course_data = info.data ? info.data : [];
      this.deadline = info.deadline;

      console.log("输出结束");
    },

    addCourse() {
      this.course_data.push({
        // id: this.course_data.length + 1,
        val0: "",
        val1: "",
        val2: "",
        val3: "",
        val4: "",
        val5: "",
        val6: "",
        val7: "",
      });

      this.person_index = this.course_data.length - 1;
      this.current_person = this.course_data[this.person_index];
      this.person_show = true;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
html,
body {
  background-color: #f8f8f8 !important;
}

.van-cell {
  border-bottom: 1px solid #ebedf0;
}

input::-webkit-input-placeholder {
  padding-top: 0;
  line-height: normal;
}

#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
#nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}

.inEdit {
  opacity: 0.4;
}

.disableText {
  color: #999999 !important;
}

.in-bl {
  display: inline-block;
}

.common-padding {
  padding: 0 0.625rem;
}
.common-padding2 {
  padding: 0.4rem 0.625rem;
}

.fc-aaaaaa-fs-nor-m {
  font-family: PingFangSC-Medium;
  font-size: 0.4375rem;
  color: #aaaaaa;
  line-height: 0.625rem;
}

.camera_text {
  line-height: 0.4rem;
  font-family: PingFangSC-Regular;
  font-size: 0.3rem;
  font-weight: normal;
  font-stretch: normal;
  letter-spacing: 0rem;
  color: #1889f9;
}

.bank-desc {
  font-family: PingFangSC-Regular;
  font-size: 0.438rem;
  color: #111111;
  line-height: 0.625rem;
}

.ps-text {
  font-size: 0.22rem;
  line-height: 0.3rem;
  color: #666666;
}
</style>
